import React, { useEffect, useState } from "react";
import Carousel from "react-multi-carousel";
import FruitCard from "./FruitCard";
import { PageSummary_SearchRequest } from "../Models/Model";
import { SimpleResponse } from "../Models/ResponseModel";
import pageService from "../Services/pageService";
import { PageType } from "../Models/Enum";
import { Container } from "react-bootstrap";
import { FruitCardresponsive } from "../Helpers/Responsive";

function FruitCardCarousel({ data, FldMapType }) {

    const [cardData, setCardData] = useState([]);

    useEffect(() => {
        getCardData();
    }, []);

    const getCardData = async () => {

        let req = new PageSummary_SearchRequest();
        if (FldMapType == 38) {
            req.PageTypeID = PageType.FruitDetail;
        }

        try {
            let resp: SimpleResponse = await pageService.getInstance().PageSummary_Search(req);
            if (resp.HasError) {
                return;
            }

            setCardData(resp.Result);

        } catch (e) {

        }
    }



    return (
        <div className="row mb-5 pb-0 pb-lg-5 ">
            <div className="col">
                <Container>
                    <div className="row CardCarousel">
                        <div className="col">
                            <Carousel responsive={FruitCardresponsive} ssr   swipeable={true} draggable={true} >
                                {cardData != undefined && cardData.length > 0 && cardData.map((item, index) => (
                                    <div key={index} className='ps-2 pe-2 mb-2 ' >
                                        <FruitCard item={item} />
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    </div>
                </Container>

            </div>
        </div>

    )
}

export default FruitCardCarousel